import { Button } from "design-system/atoms/Button"
import { Users } from "lucide-react"
import { useImpersonateOrganizationMutation } from "modules/backoffice/hooks/organizations/useImpersonateOrganizationMutation"
import { useTranslation } from "react-i18next"

type Props = {
  id: string
}

export const BackofficeImpersonateOrganization = ({ id }: Props) => {
  const { t } = useTranslation()
  const { mutateAsync } = useImpersonateOrganizationMutation()

  return (
    <Button
      variant="outline"
      className="flex gap-2 hover:bg-destructive hover:text-destructive-foreground"
      onClick={(ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        mutateAsync(id)
      }}
    >
      <Users />
      {t("backoffice.organizations.actions.impersonate")}
    </Button>
  )
}
